import axios from '../../utils/axios';

export const getMaterialPreviewsList = (params = {}, pathParams: PathParams) =>
    axios.get(`v1/materials/${pathParams.id}/previews`, { params });
